"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPermissions = void 0;
var IPermissions;
(function (IPermissions) {
    IPermissions["BADGES"] = "BADGES";
    IPermissions["CHALLENGES"] = "CHALLENGES";
    IPermissions["REWARD_TRACKS"] = "REWARD_TRACKS";
    IPermissions["ECONOMICS"] = "ECONOMICS";
    IPermissions["WALLET"] = "WALLET";
    IPermissions["CASHBACK"] = "CASHBACK";
    IPermissions["XP_POINTS"] = "XP_POINTS";
    IPermissions["TRANSACTIONS"] = "TRANSACTIONS";
    IPermissions["CUSTOMERS"] = "CUSTOMERS";
    IPermissions["STATISTICS"] = "STATISTICS";
    IPermissions["SEGMENTS"] = "SEGMENTS";
    IPermissions["EVENT_TYPES"] = "EVENT_TYPES";
    IPermissions["USERS"] = "USERS";
})(IPermissions || (exports.IPermissions = IPermissions = {}));
